import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiConnectionService } from 'src/app/services/api-connection.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare const $: any;

@Component({
  selector: 'app-construction-company-home',
  templateUrl: './construction-company-home.component.html',
  styleUrls: ['./construction-company-home.component.css'],
})
export class ConstructionCompanyHomeComponent implements OnInit {
  cityList = [];
  filters = {
    apartamento: false,
    casa: false,
    apartaestudio: false,
    ciudad: null,
    maxprice: null,
    minprice: null,
  };
  slug = null;

  seemore: boolean = false;

  tabFilter: any = [
    { name: 'Todos', value: 'all' },
    { name: 'Vivienda VIS', value: 'VIS' },
    { name: 'Vivienda no VIS', value: 'noVIS' },
    { name: 'Sobre planos', value: 'plans' },
    { name: 'En construcción', value: 'construction' },
    { name: 'Entrega inmediata', value: 'immediately' },
  ];

  openf: any = false;

  projects: any = [];

  profile: any = {};

  version: boolean = false;

  constructor(
    protected apiService: ApiConnectionService,
    protected activateRoute: ActivatedRoute
  ) {
    this.activateRoute.params.subscribe((v) => (this.slug = v.slug));
    this.activateRoute.queryParams.subscribe((params) => {
      console.log(params.v); // { orderby: "price" }
      if (params?.v == 2) {
        this.version = true;
      }
    });
  }

  ngOnInit(): void {
    this.getConstructora();
    $('.collapse').click(function (event) {
      event.stopPropagation();
    });

    $('.accordion .btn').on('click', function (event) {
      let el = event.currentTarget;
      let validation = $(el).hasClass('collapsed');

      if (validation) {
      } else {
        setTimeout(function () {
          $(el).addClass('collapsed');
        }, 200);

        setTimeout(function () {
          $(el).next('.collapse').removeClass('show');
        }, 400);
      }
    });
  }

  applyFilters() {
    console.log(this.filters);
    
  }

  filterBy(f: any) {
    this.filters[f] = !this.filters[f];
  }
  filterByCity(c: any) {
    this.filters.ciudad = c;
  }

  getConstructora() {
    this.apiService.getData('profile/' + this.slug, { auth: false }).subscribe(
      (response) => {
        this.profile = response;
        console.log(this.profile);

        this.getProyectos();
      },
      (error) => {
        Swal.fire({
          title: 'La constructora solicitada no fue encontrada',
          icon: 'Error',
        }).then(() => {
          window.history.back();
        });
      }
    );
  }

  getProyectos() {
    this.apiService
      .getData('profile/' + this.slug + '/projects', { auth: false })
      .subscribe(
        (response) => {
          this.projects = response;
          console.log(this.projects);

          var cityPrelist = [];
          for (let i = 0; i < this.projects.length; i++) {
            const pr = this.projects[i];
            if (pr.city) cityPrelist.push(pr.city);
          }
          cityPrelist = cityPrelist.filter(
            (item, index) => cityPrelist.indexOf(item) === index
          );
          this.cityList = cityPrelist.sort();
        },
        (error) => {
          Swal.fire({
            title: 'La constructora solicitada no fue encontrada',
            icon: 'Error',
          }).then(() => {
            window.history.back();
          });
        }
      );
  }
  
  openFilter() {
    this.openf = !this.openf
  }
}
